import { apiRequest } from '../../../shared/services/apiClient';
import {
  CompleteWhatsAppCloudSignupRequest,
  WhatsAppCloudSignupResult,
  WhatsAppCloudSignupSession,
} from '../types/whatsAppCloudSignup';

const pickSingle = (payload: unknown): Record<string, unknown> => {
  if (payload && typeof payload === 'object' && 'data' in (payload as Record<string, unknown>)) {
    const data = (payload as Record<string, unknown>).data;
    if (data && typeof data === 'object') {
      return data as Record<string, unknown>;
    }
  }

  return payload && typeof payload === 'object' ? payload as Record<string, unknown> : {};
};

const optionalString = (value: unknown): string | null => (
  typeof value === 'string' && value.trim() ? value : null
);

export const startWhatsAppCloudSignup = async (): Promise<WhatsAppCloudSignupSession> => {
  const payload = pickSingle(await apiRequest<unknown>('/api/v1/whatsapp-cloud/oauth/session', {
    method: 'POST',
  }));

  return {
    appId: String(payload.appId ?? ''),
    configId: String(payload.configId ?? ''),
    graphApiVersion: String(payload.graphApiVersion ?? 'v25.0'),
    state: String(payload.state ?? ''),
    sdkLocale: String(payload.sdkLocale ?? 'en_US'),
  };
};

export const completeWhatsAppCloudSignup = async (
  request: CompleteWhatsAppCloudSignupRequest,
): Promise<WhatsAppCloudSignupResult> => {
  const payload = pickSingle(await apiRequest<unknown>('/api/v1/whatsapp-cloud/oauth/complete', {
    method: 'POST',
    body: JSON.stringify(request),
  }));

  return {
    channelAccountId: String(payload.channelAccountId ?? ''),
    displayName: String(payload.displayName ?? ''),
    cloudPhoneNumberId: String(payload.cloudPhoneNumberId ?? ''),
    phoneNumber: optionalString(payload.phoneNumber),
    whatsAppAccountId: String(payload.whatsAppAccountId ?? ''),
    created: Boolean(payload.created),
    appSubscribed: Boolean(payload.appSubscribed),
    appSubscriptionError: optionalString(payload.appSubscriptionError),
  };
};
